import { Dispatch } from 'react-redux';
import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import LocalStorageManager from '../../utils/localStorage/manager';
import { ReadItemState } from './reducer';
import DownloadManagerUtils from '../../utils/downloadManager';

enum ReadItemsStatusActionKeys {
	INIT_READ_STATUS_STORE = '@@readStatus/INIT_READ_STATUS_STORE',
	UPDATE_READ_STATUS = '@@readStatus/UPDATE_READ_STATUS',
	REMOVE_ITEM = '@@readStatus/REMOVE_ITEM',
}

interface LocalStorageReadStatusInfos {
	id: number;
	lastVersionRead: number;
}

type ReadItemsStatusAction =
	| InitReadStatusStoreAction
	| UpdateReadStatusAction
	| RemoveReadItemAction;

interface InitReadStatusStoreAction extends Action {
	type: ReadItemsStatusActionKeys.INIT_READ_STATUS_STORE;
	storedReadItems: LocalStorageReadStatusInfos[];
}

interface UpdateReadStatusAction extends Action {
	type: ReadItemsStatusActionKeys.UPDATE_READ_STATUS;
	id: number;
	version: number;
}

interface RemoveReadItemAction extends Action {
	type: ReadItemsStatusActionKeys.REMOVE_ITEM;
	id: number;
}

const removeObsoleteReadItems = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	const { readStatus, driveList } = getState();
	const { driveItems } = driveList;
	const { items } = readStatus;

	Object.keys(items).forEach(id => {
		if (!driveItems[id]) {
			dispatch({
				type: ReadItemsStatusActionKeys.REMOVE_ITEM,
				id
			});
		}
	});

	return Promise.resolve();
};

const loadReadStatusStore = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const storedReadItems = LocalStorageManager.getReadStatusStore();

	if (storedReadItems) {
		dispatch({
			type: ReadItemsStatusActionKeys.INIT_READ_STATUS_STORE,
			storedReadItems
		});
	}
};

const updateReadItemsLocalStorage = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState) => {
	const { readStatus } = getState();
	const { items } = readStatus;

	let readItemsToStore: LocalStorageReadStatusInfos[] = [];

	Object.keys(items).forEach(key => {
		const id = parseInt(key, 10);
		const item: ReadItemState = items[id];

		readItemsToStore.push({
			id,
			lastVersionRead: item.lastVersionRead
		});
	});

	LocalStorageManager.setReadItems(readItemsToStore);
};

const updateLastVersionRead = (id: number) => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	const { driveList, downloadManager } = getState();
	const { driveItems } = driveList;
	const { version } = driveItems[id];

	const isDownloaded = DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, id);
	const versionToSet = isDownloaded ? downloadManager.items[id].version : version;

	dispatch({
		type: ReadItemsStatusActionKeys.UPDATE_READ_STATUS,
		id,
		version: versionToSet
	});

	dispatch(updateReadItemsLocalStorage());
};

export { ReadItemsStatusAction, ReadItemsStatusActionKeys, LocalStorageReadStatusInfos,
	updateLastVersionRead, loadReadStatusStore, removeObsoleteReadItems };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ReadStatus/actions.ts